import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SideBar',{attrs:{"bar_name":_vm.tabName,"user":_vm.user}}),_c(VMain,[_c(VContainer,[_c('NetworkShop',_vm._b({},'NetworkShop',{ user: _vm.user, tabName: 'Line User ร้านค้าเครือข่าย' },false))],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }